import { useEffect, useState } from 'react';
import { getPassTypes } from '../services/passService';

// Single-class online passes (fixed pass types, one per currency).
export const ILS_SINGLE_PASS_TYPE_ID = '6a9ef2d0760c7df1a7f2a4e7';
export const RUB_SINGLE_PASS_TYPE_ID = '6aaa732f1f2e1e1a3235df06';

// Shown until pass types load (and if the request fails).
const FALLBACK = {
  club: { eur: 50, ils: 200, rub: 5000 },
  single: { eur: 15, ils: 50, rub: 1250 },
};

function getActiveDiscount(passType) {
  const now = new Date();
  return passType.discounts?.find(
    (d) => d.active && new Date(d.validFrom) <= now && new Date(d.validTo) >= now
  );
}

// Same price rules as the server's /passes/purchase and /yookassa routes.
function subscriptionPrice(pt) {
  if (!pt) return null;
  const discountPercent = pt.subscription?.discountPercent || 0;
  return Math.round(pt.subscription?.monthlyPrice || (pt.basePrice * (1 - discountPercent / 100)));
}

function oneTimePrice(pt) {
  if (!pt) return null;
  const discountPercent = getActiveDiscount(pt)?.discountPercent || 0;
  return Math.round(pt.basePrice * (1 - discountPercent / 100));
}

/**
 * Online club + single online class prices: ₪ and ₽ amounts that are actually charged,
 * plus the display-only "≈ €" value set per pass type in admin (eurDisplayPrice).
 */
export function useOnlinePrices() {
  const [prices, setPrices] = useState(FALLBACK);

  useEffect(() => {
    getPassTypes({ all: true }).then((list) => {
      if (!Array.isArray(list) || list.length === 0) return;
      const clubIls = list.find((pt) => pt.onlineOnly && pt.currency === 'ILS');
      const clubRub = list.find((pt) => pt.onlineOnly && pt.currency === 'RUB');
      const singleIls = list.find((pt) => pt._id === ILS_SINGLE_PASS_TYPE_ID);
      const singleRub = list.find((pt) => pt._id === RUB_SINGLE_PASS_TYPE_ID);
      setPrices({
        club: {
          eur: clubIls?.eurDisplayPrice ?? clubRub?.eurDisplayPrice ?? null,
          ils: subscriptionPrice(clubIls) ?? FALLBACK.club.ils,
          rub: subscriptionPrice(clubRub) ?? FALLBACK.club.rub,
        },
        single: {
          eur: singleIls?.eurDisplayPrice ?? singleRub?.eurDisplayPrice ?? null,
          ils: oneTimePrice(singleIls) ?? FALLBACK.single.ils,
          rub: oneTimePrice(singleRub) ?? FALLBACK.single.rub,
        },
      });
    });
  }, []);

  return prices;
}
